export const schedulesList = [
  "JUN 2026",
  "SEP 2026",
  "FEB 2027"
];

export const EVENT_ID_MAP = {
  "JUN 2026": 421,
  "SEP 2026": 461,
  "FEB 2027": 462
};